<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :tipoNovedad="tipoNovedad"
          :personal="personal"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Novedades del Personal">
          <b-table class="registro" responsive="sm" 
              :busy="tableBusy"
              :items="personalNovedades" 
              :fields="personalNovedadesFields"
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner variant="primary" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaDesde)="data">
              {{ data.item.fechaDesde | fecha }}
            </template>
            <template v-slot:cell(fechaHasta)="data">
              {{ data.item.fechaHasta | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              {{ data.item.periodo | periodo_anio }}
            </template>

            <template v-slot:cell(opciones)="data" v-if="accesoABM">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editar(data.item)">
                  <i class="fa fa-edit"></i>Editar Novedad</b-dropdown-item>
                <b-dropdown-item @click.stop="borrar(data.item)">
                  <i class="fa fa-remove"></i>Borrar Novedad</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn" v-if="accesoABM">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="agregar">
            <i class="fa fa-plus"></i>Agregar Novedad</b-dropdown-item>
          <!-- <b-dropdown-item @click.stop="agregarFaltaHora">
            <i class="fa fa-plus"></i>Agregar Novedad x Hora</b-dropdown-item> -->
          <b-dropdown-item @click.stop="agregarVacaciones">
            <i class="fa fa-plus"></i>Agregar Vacaciones</b-dropdown-item>
          <!-- <b-dropdown-item @click.stop="agregarPersonalFalta">
            <i class="fa fa-plus"></i>Agregar Novedad General</b-dropdown-item> -->
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'personalNovedades/getField',
  mutationType: 'personalNovedades/updateField',
});

export default {
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal 
  ],
  name: 'PersonalNovedadesList',
  data() {
    return {
      personalNovedadesFields: [
        {
          key: 'fechaDesde',
          label: 'Desde'
        },
        {
          key: 'fechaHasta',
          label: 'Hasta'
        },
        /*
        {
          key: 'periodo',
          label: 'Período'
        },
        */
        {
          key: 'personal',
          sortable: true
        },
        {
          key: 'tipoNovedad',
          label: 'Tipo de Novedad',
          sortable: true
        },
        {
          key: 'observaciones',
        },
        { 
          key: 'opciones',
          label: ''
        },
      ],

      tableBusy: true,

      accesoABM: true,
      accesoDatos: true,
    }
  },
  computed: {
    ...mapFields([
      'personalNovedades',
      'fechaDesde',
      'fechaHasta',
      'personal',
      'tipoNovedad',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas'
    ]),
    fechaDesdeParam() {
      return moment.utc(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment.utc(this.fechaHasta).format('YYYY-MM-DD');
    },
  },
  created() {
    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('personalNovedades/getPersonalNovedades')
        .then(() => this.tableBusy = false)
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.personal = filtro.personal;
      this.tipoNovedad = filtro.tipoNovedad;
      this.paginaActual = 1;

      this.getItems();
    },    
    consultar (item) {
      if (this.accesoDatos) {
        this.$router.push({ name: 'PersonalNovedadData', 
                            params: { id: item.id }});
      }
    },
    editar (item) {
      if ((/true/i).test(item.vacaciones)) {
        this.$router.push({ name: 'PersonalNovedadVacacionesEdit', 
                            params: { id: item.id }
                          });
      } else {
        this.$router.push({ name: 'PersonalNovedadEdit', 
                            params: { id: item.id }
                          });
      }
    },
    seleccionar(item) {
      item.seleccionado = !item.seleccionado;
    },
    borrar(item) {
      this.showModalConfirm('¿Desea borrar la novedad seleccionada?', 
        this.borrarNovedad.bind(this, item.id), 'Si', null, 'No'); 
    },
    borrarNovedad(personalNovedadId) {
      this.showSpinner();
      this.$store.dispatch('personalNovedades/delete', personalNovedadId)
        .then( () => {
          this.showModalMsj ('La novedad se eliminó con éxito.', null, null, 'light');
          this.getItems();
        })
        .catch( error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    agregar () {
      this.$router.push({ name: 'PersonalNovedadAdd' });
    },
    // agregarFaltaHora () {
    //   this.$router.push({ name: 'PersonalFaltaABM',
    //                       params: { personalFaltaId: 0,
    //                                 faltaHora: Boolean(true) 
    //                               }});
    // },
    agregarVacaciones () {
      this.$router.push({ name: 'PersonalNovedadVacacionesAdd' });
    },
    // agregarPersonalFalta () {
    //   this.$router.push({ name: 'PersonalFaltaListABM' });
    // },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
